/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderStatusStatisticsVo
 */
export interface OrderStatusStatisticsVo {
    /**
     * 状态名称 韩文
     * @type {string}
     * @memberof OrderStatusStatisticsVo
     */
    nameKr?: string;
    /**
     * 状态名称 中文
     * @type {string}
     * @memberof OrderStatusStatisticsVo
     */
    nameCn?: string;
    /**
     * 状态码
     * @type {number}
     * @memberof OrderStatusStatisticsVo
     */
    statusCode?: number;
    /**
     * 订单数量
     * @type {number}
     * @memberof OrderStatusStatisticsVo
     */
    orderQuantity?: number;
    /**
     * 是否显示分割线
     * @type {boolean}
     * @memberof OrderStatusStatisticsVo
     */
    line?: boolean;
}

/**
 * Check if a given object implements the OrderStatusStatisticsVo interface.
 */
export function instanceOfOrderStatusStatisticsVo(value: object): value is OrderStatusStatisticsVo {
    return true;
}

export function OrderStatusStatisticsVoFromJSON(json: any): OrderStatusStatisticsVo {
    return OrderStatusStatisticsVoFromJSONTyped(json, false);
}

export function OrderStatusStatisticsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderStatusStatisticsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'orderQuantity': json['orderQuantity'] == null ? undefined : json['orderQuantity'],
        'line': json['line'] == null ? undefined : json['line'],
    };
}

export function OrderStatusStatisticsVoToJSON(json: any): OrderStatusStatisticsVo {
    return OrderStatusStatisticsVoToJSONTyped(json, false);
}

export function OrderStatusStatisticsVoToJSONTyped(value?: OrderStatusStatisticsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nameKr': value['nameKr'],
        'nameCn': value['nameCn'],
        'statusCode': value['statusCode'],
        'orderQuantity': value['orderQuantity'],
        'line': value['line'],
    };
}

